<template>
  <div class="columns attachment-tab">
    <div class="column is-full attachments">
      <b-field>
        <b-upload
          :native="true"
          @input="selectedDocs($event)"
          multiple
          drag-drop
        >
          <section class="section">
            <div class="content has-text-centered">
              <p>
                <b-icon icon="upload" size="is-large"> </b-icon>
              </p>
              <p>Drop your files here or click to upload</p>
            </div>
          </section>
        </b-upload>
        <b-button
          v-if="(isManagement || isTeamLeader) && student.documents.list.length"
          type="is-link"
          class="card-footer-item"
          @click="downloadAll()"
          icon-left="download"
          >Download all</b-button
        >
      </b-field>
    </div>

    <b-modal
      v-model="fileViewer.viewing"
      :width="'90vw'"
      :can-cancel="true"
      class="view-doc-modal"
    >
      <iframe
        :title="fileViewer.title"
        :src="fileViewer.file"
        frameborder="1"
        scrolling="auto"
        width="100%"
        height="100%"
      ></iframe>
    </b-modal>

    <div
      class="document-card column is-5"
      v-for="(file, index) in student.documents.list"
      :key="index"
      style="margin-top: 30px"
      :class="{ 'is-offset-1': index % 2 !== 0 }"
    >
      <header class="document-card-title" :title="file.name">
        <div class="doc-title-holder">
          <app-doc-icon :document="file.name"></app-doc-icon>
          <p class="doc-title">
            {{ file.name }}
            <br v-if="file.lastModified" />
            <span v-if="file.lastModified" class="small">
              Last Modified: {{ formatDate(file.lastModified) }}</span
            >
            <br v-if="file.lastModifiedDate" />
            <span v-if="file.lastModifiedDate" class="small">
              First uploaded: {{ formatDate(file.lastModifiedDate) }}</span
            >
            <br v-if="file.uploader_name" />
            <span v-if="file.uploader_name" class="small">
              Uploaded by: {{ file.uploader_name }}</span
            >
          </p>
          <p class="doc-description"></p>
        </div>

        <div class="document-card-actions">
          <b-button
            type="is-link"
            class="card-footer-item"
            @click="downloadItem(index)"
            icon-left="download"
          >
          </b-button>
          <b-button
            type="is-link"
            class="card-footer-item ml-2 is-success"
            @click="viewItem(index)"
            icon-left="eye"
          >
          </b-button>
          <b-button
            type="is-danger"
            class="card-footer-item ml-2"
            v-if="!file.path || !disableDocsDelete"
            @click="deleteDropFile(index)"
            icon-left="delete"
          >
          </b-button>
        </div>
      </header>

      <div class="document-card-type">
        <b-field>
          <b-autocomplete
            placeholder="Document type"
            open-on-focus
            v-model="file.docType"
            :data="filteredDocType(index)"
            icon="magnify"
            clearable
            @input="selectedFileType($event, index, file.path)"
          >
            <template #empty>No results found</template>
          </b-autocomplete>
        </b-field>
      </div>
    </div>

    <b-modal
      v-model="displayDocWizard"
      :width="800"
      has-modal-card
      full-screen
      :can-cancel="true"
    >
      <student-documents-wizard
        :studentDocuments="uploadedDocs"
        :course="course"
        @changed="documentWizardChanged"
      ></student-documents-wizard>
    </b-modal>
  </div>
</template>

<script>
import { docType } from '../../models/static';
import AppDocIcon from '../helpers/DocIcon.vue';
import UtilService from '../../services/util';
import StudentDocumentsWizard from '../student/StudentDocumentsWizard.vue';
import moment from 'moment';
import downloadBlob from '../../services/file-download';
import StudentService from '../../services/student.service';

export default {
  name: 'student-documents',
  components: {
    AppDocIcon,
    StudentDocumentsWizard,
  },
  props: ['studentDocuments', 'course', 'disableDocsDelete', 'studentId'],
  data() {
    return {
      student: {
        documents: {
          list: [],
          types: [],
        },
      },
      docType: [],
      displayDocWizard: false,
      uploadedDocs: [],
      fileViewer: {
        viewing: false,
        iframeSupported: false,
        file: null,
        title: null,
      },
    };
  },
  watch: {
    'student.documents': {
      deep: true,
      immediate: true,
      handler: function (value) {
        this.$emit('changed', value);
      },
    },
  },
  computed: {
    isManagement() {
      return UtilService.isManagement();
    },
    isTeamLeader() {
      return UtilService.isTeamLeader();
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  mounted() {
    this.student.documents = this.studentDocuments;
    this.docType = this.course.documents.length
      ? [
          ...new Set([
            ...this.course.documents.map((doc) => doc.name),
            ...docType,
          ]),
        ]
      : docType;

    setTimeout(() => {
      this.student.documents.list = [...this.student.documents.list].sort(
        (a, b) => {
          return b.lastModified - a.lastModified;
        }
      );
    }, 100);

    this.student.documents.types.forEach((docType) => {
      if (!this.docType.includes(docType)) {
        this.docType.push(docType);
      }
    });
  },
  methods: {
    deleteDropFile(index) {
      this.$buefy.dialog.confirm({
        message:
          'Are you sure you want to delete this document? This action cannot be undone',
        onConfirm: () => {
          const data = {
            studentId: this.studentId,
            id: this.student.documents.list[index].id,
          };

          const reportDoc = {
            moderatorName: this.currentUser.username,
            path: this.student.documents.list[index].name,
            studentId: this.studentId,
            moderatorId: this.currentUser.id,
          };

          this.student.documents.list.splice(index, 1);

          StudentService.deleteDoc(data).then(() => {
            StudentService.reportDeleteDoc(reportDoc);
            this.$buefy.toast.open({
              duration: 3000,
              message: `Document succesfully deleted`,
              position: 'is-bottom',
              type: 'is-success',
            });
          });
        },
      });
    },
    filteredDocType(index) {
      if (
        this.student.documents.types[index] === undefined ||
        !this.student.documents.types[index]
      ) {
        this.student.documents.types[index] = '';
      }
      return this.docType.filter((option) => {
        return option
          ? option
              .toString()
              .toLowerCase()
              .indexOf(this.student.documents.types[index].toLowerCase()) >= 0
          : false;
      });
    },
    selectedFileType(value, index, path) {
      this.student.documents.types[index] = value;
      this.student.documents.types = [...this.student.documents.types];
      this.$emit('changedDocs', {
        changedName: true,
        path,
        value,
      });
    },
    async downloadAll() {
      await this.student.documents.list.forEach((doc, index) => {
        this.downloadItem(index);
      });
    },
    async downloadItem(index) {
      const url = this.student.documents.list[index].path.replace('dist', '');
      const download = this.student.documents.list[index].name;
      const extenstion = this.student.documents.list[index].name
        .split('.')
        .pop();
      const doctype = this.student.documents.types[index];
      const newDownload = `${doctype}.${extenstion}`;
      downloadBlob(url, download);
    },
    async viewItem(index) {
      const file = this.student.documents.list[index].path.replace('dist', '');
      const suffix = UtilService.getFileExtenstion(file);
      const iframeSupported = ['pdf', 'jpg', 'jpeg', 'gif'].includes(suffix);
      const hostUrl = window.location.host.includes('localhost')
        ? 'http://192.168.50.233:8081'
        : window.location.host;
      const url = iframeSupported
        ? null
        : `https://docs.google.com/gview?url=${hostUrl + file}&embedded=true`;

      this.fileViewer = {
        viewing: true,
        iframeSupported,
        file: iframeSupported ? file : url,
        title: this.student.documents.list[index].name,
      };
    },

    formatDate(dateString) {
      if (dateString && new Date(dateString).toString() !== 'Invalid Date') {
        return moment(dateString).format('DD-MM-YYYY, h:mm:ss a');
      }

      return '';
    },

    documentWizardChanged(documents) {
      this.student.documents = {
        list: [...this.student.documents.list, ...documents.list],
        types: [...this.student.documents.types, ...documents.types],
      };

      this.$emit('changedDocs', {
        docs: {
          list: documents.list,
          types: documents.types,
        },
      });

      this.displayDocWizard = false;
    },
    selectedDocs(event) {
      this.displayDocWizard = true;
      this.uploadedDocs = event;
    },
  },
};
</script>

<style>
.columns {
  flex-wrap: wrap;
}

.view-doc-modal.modal .modal-content {
  height: 90vh;
}

.tabs li.is-active a,
.tabs li a:hover,
.tabs li.is-active a span {
  text-decoration: none;
}

.custom-autocomplete {
  height: fit-content;
}

.action-buttons {
  justify-content: center;
  display: flex;
}

.action-buttons button {
  margin: 0 10px;
}

.parent-holder {
  margin-bottom: 40px;
}

.card-holder {
  margin-top: 30px;
  margin-left: 0px;
}

div.columns.attachment-tab {
  width: 100%;
  margin-top: 30px;
}

div.columns.attachment-tab .attachments {
  justify-content: center;
  align-items: center;
  display: flex;
}

div.columns.attachment-tab .attachments .field {
  flex-direction: column;
  display: flex;
  align-items: center;
}

p.card-header-title {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

header.document-card-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

p.doc-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-left: 8px;
}

.document-card-type {
  margin-top: 12px;
}

.doc-title-holder {
  display: flex;
  align-items: center;
  max-width: calc(100% - 90px);
}
</style>
